/*
 * File: encodeValue.ts
 * Project: papa-bear
 * -----
 * Last Modified: 14 Feb 2022 12:11:18 pm
 * -----
 * Copyright (c) 2022 Elegant Software Solutions All rights reserved.
 */

interface encodedValueProps {
  doubleEncode: boolean;
  value: string;
}

export const encodeValue = ({ doubleEncode, value }: encodedValueProps): string => {
  let encodedValue = String(value);

  if (encodedValue.match(/\//g) || encodedValue.match(/\\/g) || encodedValue.match(/\+/g) || encodedValue.match(/#/g) || encodedValue.match(/~/g)) {
    // encodedValue = encodedValue.replaceAll(/\//g, '%2F');
    encodedValue = encodedValue.replaceAll(/\\/g, '%5C');
    // encodedValue = encodedValue.replaceAll(/\+/g, '%2B');
    // encodedValue = encodedValue.replaceAll(/#/g, '%23');
    // encodedValue = encodedValue.replaceAll(/~/g, '%7E');
  }

  encodedValue = doubleEncode ? encodeURIComponent(encodedValue) : encodedValue;

  return encodedValue;
};
